import { HD_CLIENT_THRESHOLD } from 'constants/UIConstants';
import { getClientWidth } from '@tock/shared/utils/responsive';
import { isHdModeEnabledSelector } from 'selectors/dashboardPreferenceSelectors';
import { useSelector } from 'react-redux';

export const useIsCompactView = () => {
  const isCompactViewEnabled = useSelector(isHdModeEnabledSelector);

  return isCompactViewEnabled && getClientWidth() > HD_CLIENT_THRESHOLD;
};
